// extracted by mini-css-extract-plugin
export default {"wizardButton":"app-react-portainer-environments-wizard-HomeView-HomeView-module__wizard-button","link":"app-react-portainer-environments-wizard-HomeView-HomeView-module__link"};